import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_shippingcontainer_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { id: number }): 
  Promise<{ result: { Id?: number, ShipmentId?: number, LicensePlates?: { Id?: number, ShipmentId?: number }[] } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.id)) {
      $missingRequiredInParams.push('\'id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      id: number    }) {
        if(isNil($inParams.id)) {
          return true; 
        }
      return false;
    }
}
